import React from 'react';
import { AdsResponse, CurrencyResponse, isActiveAdStatus, getAdStatusText } from '../../../../types/api/ads';
import { Text, Stack, Label } from '@primer/react';
import { ChevronRightIcon } from '@primer/octicons-react';

interface AdsInfoHeaderProps {
    ads: AdsResponse;
    className?: string
    imageSize: number
    nameFontSize: number
    isComplaintCard?: boolean
}

const formatPrice = (price: number, currency: CurrencyResponse): string => {
    return `${price.toLocaleString()} ${currency.symbol}`;
};

const AdsInfoHeader: React.FC<AdsInfoHeaderProps> = ({
    ads,
    className,
    imageSize = 72,
    nameFontSize = 16,
    isComplaintCard = false
}) => {
    const mainImage = ads.media?.[0]?.preview || ads.media?.[0]?.base64Preview;

    return (
        <Stack direction="horizontal" align="center" className={`${className}`}>
            {/* Изображение */}
            <div
                className="bg-header border border-border rounded-md flex-shrink-0"
                style={{
                    backgroundImage: `url("${mainImage && mainImage.trim() ? mainImage : '/icons/avatar.png'}")`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    width: `${imageSize}px`,
                    height: `${imageSize}px`
                }}
            />
            <div className="flex items-center w-full gap-4 overflow-hidden">
                <div className="flex flex-col min-w-0">
                    <Text
                        fontSize={14}
                        color="fg.default"
                        mb={2}
                        display="block"
                    >
                        {ads.category && ads.category.title} / {ads.catalog && ads.catalog.title}
                    </Text>
                    {isComplaintCard && <ChevronRightIcon className="absolute right-0 mr-8 " size={16} />}
                    <Stack direction="horizontal" align="center">
                        <Text
                            className='truncate'
                            fontSize={nameFontSize}
                            fontWeight="semibold"
                            color="fg.default"
                            lineHeight="tight">
                            {ads.title}
                        </Text>
                        {!isComplaintCard && (() => {
                            const isInArchive = !isActiveAdStatus(ads.status);

                            if (isInArchive) {
                                return <Label variant="danger" size="small">Удалено</Label>;
                            }

                            return (
                                <Label variant={isInArchive ? 'default' : 'success'} size="small">
                                    {getAdStatusText(ads.status)}
                                </Label>
                            );
                        })()}
                    </Stack>
                    <Text
                        fontSize={16}
                        fontWeight="regular"
                        color="fg.default"
                    >
                        {ads.price && ads.currency && formatPrice(ads.price, ads.currency)}
                    </Text>
                </div>
            </div>
        </Stack>
    );
};

export default AdsInfoHeader